export default "__VITE_ASSET__ad716c72__"